import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {

    let position = req.url.indexOf('admin/');
    if (position > 0){
      const idToken = sessionStorage.getItem("adminid_token");
      if (idToken) {
        const cloned = req.clone({
          headers: req.headers.set("Authorization",
            "Bearer " + idToken)
        });

        return next.handle(cloned);
      }
      else {
        return next.handle(req);
      }
    }else{
      const idToken = sessionStorage.getItem("id_token");
      if (idToken) {
        const cloned = req.clone({
          headers: req.headers.set("Authorization",
            "Bearer " + idToken)
        });

        return next.handle(cloned);
      }
      else {
        return next.handle(req);
      }
    }
    
  }
}
